module.exports = __webpack_public_path__ + "static/searchfarmers-431391ba2f7f4a95c4be8d2e46387eae.png";